<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 900px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{mode === 'edit' ? 'Edit' : 'New'}} Activity</h3>
      <div class="header-actions">
        <i class="fa" [ngClass]="{'fa-plus-square-o': activityMinimise, 'fa-minus-square-o': !activityMinimise}"
           style="margin-right: 10px; cursor: pointer;" [title]="activityMinimise ? 'Maximize' : 'Minimize'" (click)="activityMinimise = !activityMinimise"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="activityMinimise">
      <form class="activity-modal-form" (ngSubmit)="$event.preventDefault()" novalidate>
        <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
      @if (activityModalLoading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i></div>
}
      @if (!activityModalLoading) {
<div>

        <div class="row row-gray-callOut">
          <div class="row" style="margin: 10px 5px 0 5px;">
            <div class="col-md-2">
              <label>App Key: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select App Key (Channel)" direction="top"></i></label>
              <select class="form-control" [ngClass]="{'field-invalid': activityFormSubmitted && fieldErrors.channel}"
                      [(ngModel)]="activityForm.channel" (ngModelChange)="onActivityFieldChange('channel', $event)"
                      [ngModelOptions]="{standalone: true}">
                @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
              </select>
              @if (activityFormSubmitted && fieldErrors.channel) {
<span class="form-error-container">App Key is required.</span>
}
            </div>
            <div class="col-md-3">
              <label>Task</label>
              <select class="form-control" [ngClass]="{'field-invalid': activityFormSubmitted && fieldErrors.task}"
                      [(ngModel)]="activityForm.task" (ngModelChange)="onActivityFieldChange('task', $event)"
                      [ngModelOptions]="{standalone: true}">
                <option value="">none</option>
                @for (task of taskList; track $index) {
<option [ngValue]="task.task_key">{{task.indent}}{{task.task_name}}</option>
}
              </select>
              @if (activityFormSubmitted && fieldErrors.task) {
<span class="form-error-container">Task is required.</span>
}
            </div>
            <div class="col-md-2">
              <label>Start Date:</label>
              <div class="input-group">
                <input type="date" class="form-control" [ngClass]="{'field-invalid': activityFormSubmitted && fieldErrors.start_date}"
                       [(ngModel)]="activityForm.start_date" (ngModelChange)="onActivityFieldChange('start_date', $event)"
                       [ngModelOptions]="{standalone: true}">
              </div>
              @if (activityFormSubmitted && fieldErrors.start_date) {
<span class="form-error-container">Start Date is required.</span>
}
            </div>
            <div class="col-md-2">
              <label>End Date:</label>
              <div class="input-group">
                <input type="date" class="form-control" [ngClass]="{'field-invalid': activityFormSubmitted && fieldErrors.end_date}"
                       [(ngModel)]="activityForm.end_date" (ngModelChange)="onActivityFieldChange('end_date', $event)"
                       [ngModelOptions]="{standalone: true}">
              </div>
              @if (activityFormSubmitted && fieldErrors.end_date) {
<span class="form-error-container">End Date is required.</span>
}
            </div>
          </div>
        </div>

        <div class="panel panel-default" style="margin-top: 10px;" [class.panel-has-error]="activityFormSubmitted && fieldErrors.roles">
          <div class="panel-heading section-panel-heading"><h4 class="section-panel-title">Role(s)</h4></div>
          <div class="panel-body">
            @if (activityFormSubmitted && fieldErrors.roles) {
<span class="form-error-container">At least one role is required.</span>
}
            @if (activityForm.jcdTaRoleKeysToBeDeleted) {
<div class="row" style="margin-bottom: 8px;">
              <div class="col-md-6">
                <label class="label label-warning" style="font-size: 14px;">There are roles marked for deletion. These will be permanently removed only on save.</label>
              </div>
            </div>
}
            <div class="row" style="margin-left: 2px; margin-bottom: 8px;">
              @if (activityRoles.length < maxAllowedRoles) {
<button type="button" class="btn btn-sm btn-success" (click)="addActivityRole()">
                More Roles? Click to Add <i class="fa fa-plus-circle"></i>
              </button>
}
              <span class="btn btn-sm btn-warning" style="margin-left: 5px;">A maximum of only {{maxAllowedRoles}} roles are allowed</span>
            </div>
            @for (role of activityRoles; track $index; let i = $index) {
<div class="role-row">
              <div class="role-field role-field-name">
                <input type="text" class="form-control" [attr.name]="'role_name_' + i" placeholder="enter role name"
                       [ngClass]="{'field-invalid': activityFormSubmitted && roleFieldErrors[i]?.role_name}"
                       [(ngModel)]="role.role_name" (ngModelChange)="onRoleFieldChange(i, 'role_name', $event)"
                       [ngModelOptions]="{standalone: true}">
                @if (activityFormSubmitted && roleFieldErrors[i]?.role_name) {
<span class="form-error-container">Role Name is required.</span>
}
              </div>
              <div class="role-field role-field-desc">
                <textarea class="form-control role-desc-input" [attr.name]="'role_desc_' + i" placeholder="enter role description"
                          [ngClass]="{'field-invalid': activityFormSubmitted && roleFieldErrors[i]?.role_desc}"
                          [(ngModel)]="role.role_desc" (ngModelChange)="onRoleFieldChange(i, 'role_desc', $event)"
                          [ngModelOptions]="{standalone: true}"></textarea>
                @if (activityFormSubmitted && roleFieldErrors[i]?.role_desc) {
<span class="form-error-container">Role Description is required.</span>
}
              </div>
              <div class="role-field role-field-level">
                <input type="number" class="form-control" [attr.name]="'role_access_' + i" placeholder="enter access level"
                       [ngClass]="{'field-invalid': activityFormSubmitted && roleFieldErrors[i]?.access_level}"
                       [(ngModel)]="role.access_level" (ngModelChange)="onRoleFieldChange(i, 'access_level', $event)"
                       [ngModelOptions]="{standalone: true}">
                @if (activityFormSubmitted && roleFieldErrors[i]?.access_level) {
<span class="form-error-container">Access Level is required.</span>
}
              </div>
              <div class="role-field role-field-action">
                <i class="fa fa-minus-circle color-red role-delete-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Mark Role for Deletion" direction="top"
                   (click)="removeActivityRole(i); $event.stopPropagation()"></i>
              </div>
            </div>
}
          </div>
        </div>

        <div class="row" style="margin: 10px 2px;">
          @if (mode === 'edit') {
<div class="col-md-1">
            <label>Activity Key:</label>
            <div>{{activityForm.activity_key}}</div>
          </div>
}
          <div class="col-md-2">
            <label>Activity Name: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Activity display name" direction="top"></i></label>
            <input type="text" class="form-control" placeholder="enter activity name"
                   [ngClass]="{'field-invalid': activityFormSubmitted && fieldErrors.screen_name}"
                   [(ngModel)]="activityForm.screen_name" (ngModelChange)="onActivityFieldChange('screen_name', $event)"
                   [ngModelOptions]="{standalone: true}">
            @if (activityFormSubmitted && fieldErrors.screen_name) {
<span class="form-error-container">Activity Name is required.</span>
}
          </div>
          <div class="col-md-2">
            <label>Edit Level: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit level for this activity" direction="top"></i></label>
            <select class="form-control" [(ngModel)]="activityForm.edit_level" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="'O'">Open All</option>
            </select>
          </div>
          <div class="col-md-2">
            <label>Lock Level: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Lock level for this activity" direction="top"></i></label>
            <select class="form-control" [(ngModel)]="activityForm.lock_level" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="'A'">Active</option>
              <option [ngValue]="'L'">Locked</option>
              <option [ngValue]="'M'">Maintenance</option>
              <option [ngValue]="'R'">Removed</option>
            </select>
          </div>
          <div class="col-md-2">
            <label>Priority: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Activity priority" direction="top"></i></label>
            <input type="number" class="form-control" placeholder="enter priority" [(ngModel)]="activityForm.priority" [ngModelOptions]="{standalone: true}">
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-md-4">
            <div class="panel panel-default" [class.panel-has-error]="activityFormSubmitted && fieldErrors.taxtype">
              <div class="panel-heading section-panel-heading"><h4 class="section-panel-title">Tax Type(s):</h4></div>
              <div class="panel-body" style="max-height: 220px; overflow: auto;">
                @if (activityFormSubmitted && fieldErrors.taxtype) {
<span class="form-error-container">At least one Tax Type is required.</span>
}
                @for (typ of taxTypeDetails2; track $index) {
<div>
                  <label><input type="checkbox" [checked]="typ.selected" (change)="typ.selected = $any($event.target).checked; onTaxTypeSelectionChange(typ, $any($event.target).checked)"> {{typ.label}}</label>
                </div>
}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="panel panel-default">
              <div class="panel-heading section-panel-heading"><h4 class="section-panel-title">Tags:</h4></div>
              <div class="panel-body" style="min-height: 220px;">
                <div class="tags-search-wrapper">
                  <input type="text" class="form-control" [(ngModel)]="searchTagText" [ngModelOptions]="{standalone: true}" placeholder="Add Tags...">
                  <button type="button" class="btn btn-success btn-md" (click)="addTag(searchTagText)" [disabled]="!searchTagText.length">Add</button>
                </div>
                <div style="margin-top: 15px;">
                  @for (tag of addedTags; track $index; let i = $index) {
<span class="added-tags">
                    {{tag.name}}
                    <i class="fa fa-times pull-right" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Tag" direction="top" (click)="deleteTag(i)"></i>
                  </span>
}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="panel panel-default">
              <div class="panel-heading section-panel-heading"><h4 class="section-panel-title">Description:</h4></div>
              <div class="panel-body" style="min-height: 217px;">
                <textarea class="form-control" style="min-height: 185px;" [(ngModel)]="activityDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </div>
            </div>
          </div>
        </div>

      </div>
}
      </form>
    </div>
    <div class="modal-footer" [hidden]="activityMinimise">
      <button class="btn btn-primary btn-sm" type="button" (click)="saveActivityModal()">Save @if (activityCrudLoading) {
<i class="fa fa-spinner fa-spin"></i>
}</button>
      @if (mode === 'edit') {
<button class="btn btn-warning btn-sm" type="button" (click)="openAssignTemplateModal()">Assign Template</button>
}
      <button class="btn btn-warning btn-sm" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-warning btn-sm" type="button" (click)="clearActivityForm()">Clear Form</button>
      @if (mode === 'edit') {
<button class="btn btn-danger btn-sm" type="button"
        (click)="askRemoveActivity()">Remove</button>
}
    </div>
  </div>
</div>

<!-- Assign Template Modal (child of activity modal) -->
@if (showTemplateModal) {
<gtw-jdc-assign-templates-modal
 
  [activityKey]="activityForm.activity_key"
  [jcdKey]="jcdKey"
  [clientKey]="clientKey"
  [activityRoles]="activityRoles"
  (saved)="onTemplateSaved()"
  (closed)="onTemplateClosed()">
</gtw-jdc-assign-templates-modal>
}

<!-- Confirmation Modal (internal) -->
@if (showConfirmModal) {
<div class="modal-overlay" style="z-index: 1060;" (click)="cancelConfirm()">
  <div (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="executeConfirm()"
      (cancelled)="cancelConfirm()"
      (closed)="cancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
